// removed by extract-text-webpack-plugin
module.exports = {"form_wrapper":"_3LpfS","form_name":"yZuzN","form_select":"Ehdwk","form_select_dropdown":"_2T3YZ","form_input":"_2Y0i1","form_btn_wrapper":"_12lUz","form_collapse":"_48bmf","button":"_1oSjm","btn_primary":"_2m__u _1oSjm _2m__u _1oSjm","btn_secondary":"_84iXE _1oSjm","btn_warning":"_3Qh0M _84iXE _1oSjm _3Qh0M _84iXE _1oSjm","root":"KI6jL","input_wrapper":"_1gQUs _3LpfS","input_name":"_2aCzK _1I1NP","text_input":"_86WKL _2Y0i1","button_wrapper":"_jHWv _12lUz"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/contacts/RenameUser.css
// module id = 926
// module chunks = 0